module.exports = __webpack_public_path__ + "static/media/concurrent.09ad1ff1.svg";